import { render } from "./AppSidebar.vue?vue&type=template&id=77d9b992&scoped=true&ts=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"

import "./AppSidebar.vue?vue&type=style&index=0&id=77d9b992&lang=scss&scoped=true"

import exportComponent from "/Users/lk/Documents/SecondCorner/programs/sc_backend_v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d9b992"]])

export default __exports__